require.register("modules/m06/dnu-opt-mod-he-activity/page-45/page-45", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page45 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page45;

  
});

